export enum FacadeElementType {
    StandardPanel = 1,
    StandardCorner = 2,
    CustomPanel = 3,
    CustomCorner = 4,
    CustomZShaped = 5,
}
